import { makeStyles } from '@material-ui/core/styles';

export const useButtonStyles = makeStyles(theme => ({
	root: {
		width: props => props.width,
		height: props => props.height,
		fontWeight: props => (props.bold ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular),
		textTransform: props => (props.noTextTransform ? 'none' : 'uppercase'),
		whiteSpace: 'nowrap'
	},
	startIcon: {
		marginRight: 4
	},
	endIcon: {
		marginLeft: 5,
		marginRight: -8,
		'&.MuiButton-iconSizeSmall': {
			marginRight: -5
		}
	},
	textSizeSmall: {
		padding: '5px 11px'
	},
	contained: {
		color: `${theme.palette.text.gumetal} !important`
	}
}));
